import { render, staticRenderFns } from "./Tirage_deatille_facture.vue?vue&type=template&id=8cdbfe5e&"
import script from "./Tirage_deatille_facture.vue?vue&type=script&lang=js&"
export * from "./Tirage_deatille_facture.vue?vue&type=script&lang=js&"
import style0 from "./Tirage_deatille_facture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports